<div role="contentinfo" class="footer text-white text-center bg-white">
  <a target="_blank" href="{{ 'footer.privacy.policy.link' | translate }}" class="text-center text-black fw-bold">{{
    'footer.privacy.policy' | translate
  }}</a>

  <img alt="" class="club-logo" src="assets/images/logo.svg" draggable="false" />

  <img alt="" class="stadium-logo py-3" src="assets/images/footer/hill-dickinson.png" draggable="false" />

  <div class="footer-row row-one">
    <img alt="" class="row-one-logo" src="assets/images/footer/castore.png" draggable="false" />
    <img alt="" class="row-one-logo" src="assets/images/footer/fanatics.png" draggable="false" />
    <img alt="" class="row-one-logo" src="assets/images/footer/christopher-ward.png" draggable="false" />
    <ng-container *notInPopulation="populations.U18">
      <img alt="" class="row-one-logo" src="assets/images/footer/budwiser.png" draggable="false" />
    </ng-container>
    <img alt="" class="row-one-logo" src="assets/images/footer/seat-unique.png" draggable="false" />
  </div>

  <!--Desktop Footer-->
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="footer-row">
      <img alt="" class="row-two-logo" src="assets/images/footer/ticketmaster.png" draggable="false" />
      <ng-container *notInPopulation="populations.U18">
        <img alt="" class="row-two-logo" src="assets/images/footer/socios.png" draggable="false" />
      </ng-container>
      <ng-container *notInPopulation="populations.U18">
        <img alt="" class="row-two-logo" src="assets/images/footer/nemiroff.png" draggable="false" />

        <img alt="" class="row-two-logo" src="assets/images/footer/etoro.png" draggable="false" />
      </ng-container>
      <img alt="" class="row-two-logo" src="assets/images/footer/redbull.png" draggable="false" />
      <img alt="" class="row-two-logo" src="assets/images/footer/ocs.png" draggable="false" />
    </div>

    <div class="footer-row">
      <img alt="" class="row-three-logo" src="assets/images/footer/corpay.png" draggable="false" />
      <img alt="" class="row-three-logo" src="assets/images/footer/sportsbreaks.png" draggable="false" />
      <img alt="" class="row-three-logo" src="assets/images/footer/marc-darcy.png" draggable="false" />
      <img alt="" class="row-three-logo" src="assets/images/footer/davanti-tyres.png" draggable="false" />
    </div>
  </ng-container>

  <!--Mobile Footer-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <div class="footer-mobile-row">
      <img alt="" class="mobile-logo" src="assets/images/footer/ticketmaster.png" draggable="false" />
      <ng-container *notInPopulation="populations.U18">
        <img alt="" class="mobile-logo" src="assets/images/footer/socios.png" draggable="false" />
      </ng-container>
      <ng-container *notInPopulation="populations.U18">
        <img alt="" class="mobile-logo" src="assets/images/footer/nemiroff.png" draggable="false" />

        <img alt="" class="mobile-logo" src="assets/images/footer/etoro.png" draggable="false" />
      </ng-container>

      <ng-container *inPopulation="populations.U18">
        <img alt="" class="mobile-logo" src="assets/images/footer/redbull.png" draggable="false" />
        <img alt="" class="mobile-logo" src="assets/images/footer/ocs.png" draggable="false" />
      </ng-container>
    </div>

    <ng-container *notInPopulation="populations.U18">
      <div class="footer-mobile-row-gap">
        <img alt="" class="mobile-logo" src="assets/images/footer/redbull.png" draggable="false" />
        <img alt="" class="mobile-logo" src="assets/images/footer/ocs.png" draggable="false" />
      </div>
    </ng-container>

    <div class="footer-mobile-row">
      <img alt="" class="mobile-logo" src="assets/images/footer/corpay.png" draggable="false" />
      <img alt="" class="mobile-logo" src="assets/images/footer/sportsbreaks.png" draggable="false" />
      <img alt="" class="mobile-logo" src="assets/images/footer/marc-darcy.png" draggable="false" />
      <img alt="" class="mobile-logo" src="assets/images/footer/davanti-tyres.png" draggable="false" />
    </div>
  </ng-container>
</div>
